$(document).ready(function() {
  const pageClass               = ".manager-report-page";
  const urlForGenerateReport    = "/manager_reporting/reports";
  const urlForAvailableManagers = "/manager_reporting/reports/available_managers.json";

  // Keep track of the items that the user
  // has selected during the wizard.

  const filters = {
    manager_ids:                   [],
    manager_preset_ids:            [],
    group_ids:                     [],
    columns_for_summary:           [],
    columns_for_managers_overview: [],
    columns_for_connections:       [],
  }

  const showAndHideSearchFilters = function(selection) {
    switch (selection) {
      case "managers":
        $(`${pageClass} #search-managers`).show();
        $(`${pageClass} #search-manager-presets`).hide();
        $(`${pageClass} #search-groups`).hide();
        break;
      case "manager-presets":
        $(`${pageClass} #search-managers`).hide();
        $(`${pageClass} #search-manager-presets`).show();
        $(`${pageClass} #search-groups`).hide();
        break;
      case "groups":
        $(`${pageClass} #search-managers`).hide();
        $(`${pageClass} #search-manager-presets`).hide();
        $(`${pageClass} #search-groups`).show();
        break;
      default:
        break;
    }
  }

  // For every search result, show those that match
  // the downcased search query by name. Hide the others.

  const liveSearch = function({ documentField, searchField, container, searchContainer, dataField }) {
    let documentObject = document[documentField];

    $(pageClass).on("keyup", searchField, function(event) {
      if (!!documentObject) {
        clearTimeout(documentObject);
      }

      return documentObject = setTimeout(function() {
        const text = $(event.target).val().toLowerCase();

        if (!!text) {
          let matchFound = false;

          $(searchContainer).find(`[data-${dataField}]`).each(function() {
            const name = $(this).attr(`data-${dataField}`).toLowerCase();

            if (name.indexOf(text) !== -1) {
              matchFound = true;
              $(this).removeClass("not-matched");
              $(this).addClass("matched");
            }
            else {
              $(this).removeClass("matched");
              $(this).addClass("not-matched");
            }
          });

          if (matchFound) {
            $(container).find(".select-all-search-results-container").show();
            $(searchContainer).find(".no-search-results").hide();
          }
          else {
            $(searchContainer).find(".no-search-results").show();
            $(container).find(".select-all-search-results-container").hide();
          }
        }
        else {
          $(searchContainer).find(`[data-${dataField}]`).removeClass("not-matched");
          $(searchContainer).find(`[data-${dataField}]`).addClass("matched");

          if ($(`${container} input[name='available-item']`).length > 0) {
            $(container).find(".select-all-search-results-container").show();
            $(searchContainer).find(".no-search-results").hide();
          }
          else {
            $(searchContainer).find(".no-search-results").show();
          }
        }
      }, 1000);
    });
  }

  // As soon as 1 Manager, ManagerPreset or Group is selected,
  // the other filters are cleared and the checkboxes are deselected.
  // Also, the next button will show.
  //
  // This is necessary, because you can only search on
  // Manager, ManagerPreset OR Groups. Not a combination of them.
  //
  // For every selected item, keep track of it in the corresponding filters
  // variable. The other filter variables are cleared.

  const keepTrackOfSearchResultsSelected = function({ filter, container }) {
    const keepTrack = function({ filter, container }) {
      const searchResultsSelected = $(`${pageClass} ${container} input[name='available-item']:checked`);
      const actionNextStep        = $(`${pageClass} ${container} .action.next-step.select-at-least-one-item`);
      const selectedIds           = $.map(searchResultsSelected, function (element, index) {
        return parseInt($(element).val(), 10);
      });

      switch (filter) {
        case "manager_ids":
          filters.manager_ids        = selectedIds;
          filters.manager_preset_ids = [];
          filters.group_ids          = [];
          break;
        case "manager_preset_ids":
          filters.manager_ids        = [];
          filters.manager_preset_ids = selectedIds;
          filters.group_ids          = [];
          break;
        case "group_ids":
          filters.manager_ids        = [];
          filters.manager_preset_ids = [];
          filters.group_ids          = selectedIds;
          break;
        default:
          break;
      }

      if (searchResultsSelected.length > 0) {
        // Clear all the checkboxes from the other filters,
        // since we've chosen one from the current filter.
        // For instance, if we choose the Managers filter,
        // select an item, and then choose the ManagerPresets filter,
        // and then choose an item, then all the selected
        // items from the Managers filter will be unselected,
        // while the ones in the ManagerPresets filter remain.

        const allSelectionContainers = $(`${pageClass} .selection-container`);

        allSelectionContainers.each(function(index) {
          const selectionContainer  = allSelectionContainers[index];
          const closestSearchFilter = $(selectionContainer).closest(".search-filter")[0];

          if (closestSearchFilter !== undefined) {
            const closestSearchFilterId = `#${closestSearchFilter.id}`;

            if (closestSearchFilterId !== container) {
              $(selectionContainer).find("input[name='available-item']").prop("checked", false);
            }
          }
        });

        actionNextStep.removeClass("disabled");
        actionNextStep.addClass("enabled");
      }
      else {
        actionNextStep.removeClass("enabled");
        actionNextStep.addClass("disabled");
      }
    }

    $(pageClass).on("change", `${container} input.select-all-search-results`, function(event) {
      // Only select the matched items. If we do a live search and get back
      // 3 results, then selecting all will only select those 3, and not
      // the entire search results containing both the matched and unmatched ones.
      $(`${pageClass} ${container} .search-result-details.matched input[name='available-item']`).prop("checked", this.checked);

      if (this.checked) {
        $(`${pageClass} ${container} .select-all-label`).text("Deselect all");
      }
      else {
        $(`${pageClass} ${container} .select-all-label`).text("Select all");
      }

      keepTrack({ filter: filter, container: container });
    });

    $(pageClass).on("change", `${container} input[name='available-item']`, function(event) {
      keepTrack({ filter: filter, container: container });
    });
  }

  // For every tab in the Excel output, there is a list of columns
  // that the user can choose from. At least 1 column per tab
  // has to be selected in order to progress the wizard.

  const keepTrackOfColumnsSelected = function({ filter, container }) {
    const keepTrack = function({ filter, container }) {
      const columnsSelected = $(`${pageClass} ${container} input[type='checkbox'].column-item:checked`);
      const actionNextStep  = $(`${pageClass} ${container} .action.next-step.select-at-least-one-item`);
      const selectedColumns = $.map(columnsSelected, function (element, index) {
        return $(element).val();
      });

      filters[filter] = selectedColumns;

      if (columnsSelected.length > 0) {
        actionNextStep.removeClass("disabled");
        actionNextStep.addClass("enabled");
      }
      else {
        actionNextStep.removeClass("enabled");
        actionNextStep.addClass("disabled");
      }
    }

    $(pageClass).on("change", `${container} input.select-all-columns`, function(event) {
      $(`${pageClass} ${container} input[type='checkbox'].column-item`).prop("checked", this.checked);

      if (this.checked) {
        $(`${pageClass} ${container} .select-all-label`).text("Deselect all");
      }
      else {
        $(`${pageClass} ${container} .select-all-label`).text("Select all");
      }

      keepTrack({ filter: filter, container: container });
    });

    $(pageClass).on("change", `${container} input[type='checkbox'].column-item`, function(event) {
      keepTrack({ filter: filter, container: container });
    });
  }

  // Make sure to have the browser perform
  // a regular POST call instead of an AJAX call,
  // otherwise the Excel file won't be properly
  // downloaded.

  const createFormAndAutoSubmit = function() {
    const form = $("<form>", {
      action: urlForGenerateReport,
      method: "POST"
    });

    $("<input>").attr({
      type:  "hidden",
      name:  "authenticity_token",
      value: $("meta[name='csrf-token']").attr("content")
    }).appendTo(form);

    for (const [key, values] of Object.entries(filters)) {
      for (const value of values) {
        $("<input>").attr({
          type:  "hidden",
          name:  `manager_report[${key}][]`, // Make sure it's an array
          value: value
        }).appendTo(form);
      }
    }

    form.appendTo("body").submit();
    form.remove();
  }

  // Search for available managers based on the
  // name, status and created_at fields.

  const searchAvailableManagers = function() {
    const selectAllSearchResults = $(`${pageClass} #search-managers input.select-all-search-results`);
    const selectAllSearchResultsContainer = $(`${pageClass} #search-managers .select-all-search-results-container`);
    const loading = `
      <div class="smdc-search-result-select">
        <div><i class="fa fa-spinner fa-spin fa-2x"></i></div>
      </div>
    `;

    selectAllSearchResultsContainer.hide();
    $("#selection-container-managers").html(loading);

    $.ajax({
      url:      urlForAvailableManagers,
      method:   "POST",
      dataType: "json",
      data:     {
        authenticity_token:    $("meta[name='csrf-token']").attr("content"),
        status:                $(`${pageClass} #search-managers input[type='radio'][name='manager_status']:checked`).val(),
        search:                $(`${pageClass} #search-managers #multi-search-managers`).val(),
        created_at_start_date: $(`${pageClass} #search-managers #created_at_start_date`).val(),
        created_at_end_date:   $(`${pageClass} #search-managers #created_at_end_date`).val(),
      }
    }).done(function(data) {
      let html;

      if (data.length > 0) {
        // Clear all filters since the user has to
        // choose again.

        filters.manager_ids        = [];
        filters.manager_preset_ids = [];
        filters.group_ids          = [];

        // Even if you've selected all, with new search results,
        // the previous selected ones will be gone, and you have
        // to select new ones anyway.

        $(`${pageClass} #search-managers .select-all-label`).text("Select all");
        selectAllSearchResults.prop("checked", false);
        selectAllSearchResultsContainer.show();

        const searchResults = $.map(data, function (element, index) {
          return `
            <div class="search-result-details matched" data-manager-name="${element.name}">
              <div class="smdc-radio left">
                <input id="option-manager-${element.id}" name="available-item" value="${element.id}" type="checkbox">
                <div class="check"></div>
                <label for="option-manager-${element.id}"></label>
              </div>
              <div class="search-result-avatar">
                <div class="avatar-abbreviation purple-circle">
                  <h5>${element.initials}</h5>
                </div>
                <ul>
                  <li>
                    <h5>
                      <label for="option-manager-${element.id}">${element.name}</label>
                    </h5>
                  </li>
                </ul>
              </div>
            </div>
          `;
        }).join("\n");

        html = `
          <div class="smdc-search-result-select">
            <div class="no-search-results">No search results available.</div>
            ${searchResults}
          </div>
          <div class="action generate-btns next-step select-at-least-one-item disabled right">
            <input type="submit" name="commit" value="next" class="whitebtn right">
          </div>
        `;
      }
      else {
        selectAllSearchResultsContainer.hide();

        html = `
          <div class="smdc-search-result-select">
            <div>No search results available.</div>
          </div>
        `;
      }

      $("#selection-container-managers").html(html);

      // Since event delegation for the datepicker doesn't work
      // we have to use the same on change handler again.
      // This is a limitation of the datepicker.
      $(`${pageClass} #search-managers .datepicker`).on("change", function(event) {
        searchAvailableManagers();
      });
    }).fail(function(error) {
      alert("Something went wrong while trying to search for available managers. Please try again.");
    });
  }

  // Use event delegation, so that even when the server renders
  // the search results for Managers, the event handlers don't have
  // to be registered again.

  const setupEventHandlers = function() {
    // Show the previous step. It's based on the data-previous-step
    // attribute set in the step partials.

    $(pageClass).on("click", ".step .previous-step input[type='submit']", function(event) {
      const currentStep  = $(this).closest(".step");
      const previousStep = currentStep.attr("data-previous-step");
      const regex        = /#step\d+/;

      if (regex.test(previousStep)) {
        $(currentStep).hide();
        $(previousStep).show();
      }
    });

    // Show the next step. It's based on the data-next-step
    // attribute set in the step partials.
    //
    // If it's the last step, make sure to show the "Generate report"
    // button instead of "Next".
    //
    // Also, if this was the last step, have the form submit
    // so the Excel report can be generated + downloaded.

    $(pageClass).on("click", ".step .next-step input[type='submit']", function(event) {
      const currentStep = $(this).closest(".step");
      const nextStep    = currentStep.attr("data-next-step");
      const regex       = /#step\d+/;

      if (regex.test(nextStep)) {
        if ($(nextStep).attr("data-next-step") === "false") {
          $(nextStep).find(".action.next-step input[type='submit']").val("Generate report");
        }

        $(currentStep).hide();
        $(nextStep).show();
      }
      else if (nextStep === "false") {
        createFormAndAutoSubmit();
      }
    });

    // Toggle between the Manager, ManagerPreset and Group filters.

    $(pageClass).on("change", "#filter-type", function(event) {
      const selection = $(this).val();
      showAndHideSearchFilters(selection);
    });

    // As soon as the Manager status filter changes,
    // perform a search server side.

    $(pageClass).on("change", "#search-managers input[type='radio'][name='manager_status']", function(event) {
      searchAvailableManagers();
    });

    // As soon as the Manager created_at filter changes,
    // perform a search server side.
    //
    // Notice that event delegation for the datepicker doesn't work
    // and we have to use the same on change handler in searchAvailableManagers()
    // again. This is a limitation of the datepicker.
    $(`${pageClass} #search-managers .datepicker`).on("change", function(event) {
      searchAvailableManagers();
    });

    const selection = $(`${pageClass} #filter-type`).val();
    showAndHideSearchFilters(selection);

    liveSearch({ documentField: "searchingManagers",       searchField: "#multi-search-managers",        container: "#search-managers" ,       searchContainer: "#selection-container-managers",        dataField: "manager-name" });
    liveSearch({ documentField: "searchingManagerPresets", searchField: "#multi-search-manager-presets", container: "#search-manager-presets", searchContainer: "#selection-container-manager-presets", dataField: "manager-preset-name" });
    liveSearch({ documentField: "searchingGroups",         searchField: "#multi-search-groups",          container: "#search-groups",          searchContainer: "#selection-container-groups",          dataField: "group-name" });

    keepTrackOfSearchResultsSelected({ filter: "manager_ids",        container: "#search-managers" });
    keepTrackOfSearchResultsSelected({ filter: "manager_preset_ids", container: "#search-manager-presets" });
    keepTrackOfSearchResultsSelected({ filter: "group_ids",          container: "#search-groups" });

    keepTrackOfColumnsSelected({ filter: "columns_for_summary",           container: "#columns-for-summary" });
    keepTrackOfColumnsSelected({ filter: "columns_for_managers_overview", container: "#columns-for-managers-overview" });
    keepTrackOfColumnsSelected({ filter: "columns_for_connections",       container: "#columns-for-connections" });
  }

  setupEventHandlers();
});
